import { render, staticRenderFns } from "./BoletoUrl.vue?vue&type=template&id=6e2123b5"
import script from "./BoletoUrl.vue?vue&type=script&lang=js"
export * from "./BoletoUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports